import gql from 'graphql-tag'

const CALCULATE = gql`
  mutation($cartId: String!, $destinationPostalCode: String!) {
    calculate(cart_id: $cartId, destination_postal_code: $destinationPostalCode) {
      destinationAddress {
        city
        state
        street
      }
      services {
        shippingName
        deadline
        name
        value
      }
    }
  }
`

export {
  CALCULATE
}
